import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

function App() {
  const navigate = useNavigate();

  const navtoAssess = () => {
    navigate('/assess-form');
  }
  return (
    <div>
    <Helmet>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"></meta>
    </Helmet>
    <div class="flex-container">
      <div class="flex-child-gen">
        <div class="genome-bg-hover">
          <img className='bg-1' src={require("./background/bg-1.jpg")} alt=''></img>
          <div class="genome-overlay">
            <Button variant='danger' size='lg' onClick={navtoAssess}>To upload</Button>
          </div>
          <div class="genome-heading">
            <span>Analyze mammogram</span> 
          </div>
        </div>
      </div>
      
    </div>
    </div>
  );
}

export default App;
